import { SourceTypeChip } from "components/shared";
import { Source } from "interfaces";

export const HeaderDetailSource = ({ source }: { source: Source }) => {
  return (
    <>
      <SourceTypeChip type={source.type} />
      <div className="margin-top-8 width-100">
        <span className="text-title-bold capitalize">{source.name}</span>
      </div>
    </>
  );
};
